module.exports = __webpack_public_path__ + "static/img/sec5-cont02-sub02@w.3e412eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec5-cont02-sub02@w.png
// module id = kevg
// module chunks = 0